export const defaultTvLiveConfig = {
  nextImageAspectRatio: '16/9',
  tvGuideEnabled: false
};